import React from 'react';
import { ShieldCheck, Sparkles, Gem } from 'lucide-react';
import CaratsAndGold from './CaratsAndGold.png';
import CaratsAndGoldLogo from './CaratsGoldLogo.png';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL } from '../Components/Constant';
import { Input, Select, Button, message } from 'antd';
/*
  ✅ COMPLETELY INDEPENDENT LANDING PAGE
  ❌ No shared components
  ❌ No external theme dependency
  ✔ Gold & Silver luxury theme inspired by logo
*/

const COLORS = {
    background: '#0B0B0B',
    surface: '#151515',
    gold: '#C9A24D',
    goldDark: '#9E7C2F',
    silver: '#E5E5E5',
    textPrimary: '#FFFFFF',
    textSecondary: '#CFCFCF',
};

const products = [
    {
        title: 'Diamond Necklaces',
        description: 'Brilliantly crafted diamond necklaces blending elegance with timeless luxury.',
        image: 'https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?auto=format&fit=crop&w=900&q=80',
        tags: ['VVS Diamonds', '18K Gold', 'Certified'],
    },
    {
        title: 'Gold Bangles',
        description: 'Pure gold bangles designed with heritage craftsmanship and modern aesthetics.',
        image: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?auto=format&fit=crop&w=900&q=80',
        tags: ['BIS Hallmarked', 'Custom Fit', 'Luxury Finish'],
    },
    {
        title: 'Engagement Rings',
        description: 'Iconic diamond engagement rings that celebrate love and commitment.',
        image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=900&q=80',
        tags: ['Conflict-Free', 'Custom Engraving', 'Lifetime Care'],
    },
];






export default function CaratsAndGoldLandingPage() {
    const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    const navigate = useNavigate();
    const [formData, setFormData] = React.useState({
        name: '',
        companyName: '',
        contactNo: '',
        email: '',
        address: {
            street: '',
            city: '',
            state: '',
            country: '',
            postal_code: '',
        },
        username: '',
        ipAddress: '',
    });
    const [loading, setLoading] = React.useState(false);



    React.useEffect(() => {
    const fetchIp = async () => {
        try {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setFormData(prev => ({
                ...prev,
                ipAddress: data.ip
            }));
        } catch (err) {
            console.error("Failed to fetch IP address", err);
        }
    };

    fetchIp();
}, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation: Check if all required fields are filled
        if (!formData.name || !formData.companyName || !formData.contactNo || !formData.email || !formData.address.country || !formData.username) {
            message.error('Please fill all required fields!');
            return;
        }

        setLoading(true);

        try {
            // Get token from cookies
            const token = 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiNjk3MWQ1OWRkZWZiMjIzNGY2YzE1ZmIyIiwib3JnX2lkIjoiNjk3MDgzZGFjYTI1NDQyMTgyMzVlZjg0IiwidXNlcl9yb2xlIjpudWxsfQ.tjUdOipphDmE23kVrMxjzJbzsXuhmG02KxeDglbWwIg';

            // Prepare the body for the API
            const body = {
                object_name: "Lead",
                data: {
                    Name: formData.name,
                    CompanyName: formData.companyName,
                    User: "6971d59ddefb2234f6c15fb2",
                    ContactNo: formData.contactNo,
                    Email: formData.email,
                    Address: formData.address,
                    Username: formData.username,
                    Status:"Open",
                    IpAddress: formData.ipAddress,
                }
            };


            console.log("Request Body:", body);
            const response = await axios.post(
                `${BASE_URL}/insert_or_update_records`,
                body,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                message.success('Lead created successfully! Please check your email for confirmation.');
                // Reset form
                setFormData({
                    name: '',
                    companyName: '',
                    contactNo: '',
                    email: '',
                    address: {
                        street: '',
                        city: '',
                        state: '',
                        country: '',
                        postal_code: '',
                    },
                    username: '',
                });
                // Scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (error) {
            console.error('Error creating lead:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to create lead. Please try again.';
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={{ background: COLORS.background, color: COLORS.textPrimary, fontFamily: 'Inter, sans-serif' }}>
            {/* HEADER */}
            <header
                style={{
                    position: 'fixed',
                    top: 0,
                    width: '100%',
                    background: 'rgba(11,11,11,0.9)',
                    backdropFilter: 'blur(6px)',
                    zIndex: 10,
                    padding: '16px 32px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontSize: 20,
                        fontWeight: 700,
                    }}
                >
                    {/* LOGO IMAGE */}
                    <img
                        src={CaratsAndGoldLogo}
                        alt="Carats & Gold Logo"
                        style={{
                            height: 32,      // adjust as needed
                            width: "auto",
                            objectFit: "contain",
                        }}
                    />

                    {/* BRAND TEXT */}
                    <div>
                        <span style={{ color: COLORS.gold }}>Carats</span>{" "}
                        <span style={{ color: COLORS.silver }}>& Gold</span>
                    </div>
                </div>

                <nav style={{ display: "flex", gap: 24, alignItems: "center" }}>
                    <button onClick={() => scrollTo("collections")} style={navBtnStyle}>
                        Collections
                    </button>
                    <button onClick={() => scrollTo("craft")} style={navBtnStyle}>
                        Craft
                    </button>
                    <button onClick={() => scrollTo("contact")} style={navBtnStyle}>
                        Contact
                    </button>

                    {/* SIGN IN BUTTON */}
                    <button
                        onClick={() => navigate("/login")}
                        style={{
                            padding: "8px 20px",
                            borderRadius: 20,
                            border: `1px solid ${COLORS.gold}`,
                            background: "transparent",
                            color: COLORS.gold,
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Sign In
                    </button>

                    {/* SIGN UP BUTTON */}
                    <button
                        onClick={() => scrollTo("signup")}
                        style={{
                            padding: "8px 20px",
                            borderRadius: 20,
                            background: COLORS.gold,
                            color: "#000",
                            border: "none",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Sign Up
                    </button>
                </nav>

            </header>

            {/* HERO */}
            <section
                style={{
                    marginTop: 10, // just to offset fixed header height
                }}
            >
                {/* FULL WIDTH IMAGE */}
                <div
                    style={{
                        width: "100%",
                        height: "70vh", // adjust if you want taller
                        overflow: "hidden",
                        marginBottom: "-80px",

                    }}
                >
                    <img
                        src={CaratsAndGold}
                        alt="Carats and Gold"

                        style={{
                            width: "100%",
                            height: "80%",
                            objectFit: "contain",
                            display: "block",

                        }}
                    />
                </div>

                {/* TEXT BELOW IMAGE */}
                <div
                    style={{
                        textAlign: "center",
                        padding: "10px",
                        marginTop: 10,
                        background: "radial-gradient(circle at top, #222, #0B0B0B)",
                    }}
                >
                    <h1 style={{ fontSize: 56, fontWeight: 800 }}>
                        Luxury Gold & Diamond Jewellery
                    </h1>

                    <p
                        style={{
                            maxWidth: 760,
                            margin: "24px auto",
                            color: COLORS.textSecondary,
                            fontSize: 20,
                        }}
                    >
                        Manufacturers of premium gold and diamond jewellery crafted for generations.
                    </p>

                    <button onClick={() => scrollTo("collections")} style={primaryBtnStyle}>
                        Explore Collections
                    </button>
                </div>
            </section>



            {/* COLLECTIONS */}
            <section id="collections" style={{ padding: '96px 24px' }}>
                <h2 style={sectionTitle}>Signature Collections</h2>
                <div style={productGrid}>
                    {products.map((p) => (
                        <div key={p.title} style={productCard}>
                            <img src={p.image} alt={p.title} style={productImage} />
                            <div style={{ padding: 24 }}>
                                <h3 style={{ fontSize: 22 }}>{p.title}</h3>
                                <p style={{ color: COLORS.textSecondary, margin: '12px 0' }}>{p.description}</p>
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                    {p.tags.map((t) => (
                                        <span key={t} style={tag}>{t}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            {/* CRAFT */}
            <section id="craft" style={{ padding: '96px 24px', background: COLORS.surface }}>
                <h2 style={sectionTitle}>Crafted With Excellence</h2>
                <div style={featureGrid}>
                    <Feature icon={ShieldCheck} title="Certified Purity" desc="BIS hallmarked gold & certified diamonds." />
                    <Feature icon={Sparkles} title="Luxury Design" desc="Timeless designs inspired by global elegance." />
                    <Feature icon={Gem} title="Master Craftsmanship" desc="Expert artisans with decades of experience." />
                </div>
            </section>

            {/* CONTACT / CTA */}
            <section
                id="contact"
                style={{ padding: '96px 24px', textAlign: 'center', background: 'linear-gradient(135deg, #1C1C1C, #0B0B0B)' }}
            >
                <h2 style={{ fontSize: 40 }}>Experience Timeless Luxury</h2>
                <p style={{ maxWidth: 720, margin: '16px auto', color: COLORS.textSecondary }}>
                    Visit our showroom or connect with us to create jewellery that lasts forever.
                </p>
                <button onClick={() => scrollTo('collections')} style={secondaryBtnStyle}>
                    Back to Collections
                </button>
            </section>

            {/* SIGNUP FORM SECTION */}
            <section
                id="signup"
                style={{ padding: '96px 24px', background: COLORS.surface }}
            >
                <div style={{ maxWidth: 700, margin: '0 auto' }}>
                    <h2 style={{ fontSize: 40, textAlign: 'center', marginBottom: 32 }}>Join Carats & Gold</h2>
                    <p style={{ textAlign: 'center', color: COLORS.textSecondary, marginBottom: 32 }}>
                        Create an account to access exclusive offers and collections
                    </p>

                    <form
                        onSubmit={handleSubmit}
                        style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}
                    >
                        {/* COMPANY NAME FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Company Name <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Input
                                type="text"
                                placeholder="Company Name"
                                value={formData.companyName}
                                onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                                required
                            />
                        </div>

                        {/* NAME FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Name <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Input
                                type="text"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                                required
                            />
                        </div>

                        {/* CONTACT NO FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Contact No. <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Input
                                type="tel"
                                placeholder="1234567890"
                                value={formData.contactNo}
                                onChange={(e) => setFormData({ ...formData, contactNo: e.target.value })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                                required
                            />
                        </div>

                        {/* EMAIL FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                E-mail <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Input
                                type="email"
                                placeholder="xyz@infosystems.com"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                                required
                            />
                        </div>

                        {/* ADDRESS/STREET FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Street Address
                            </label>
                            <Input
                                type="text"
                                placeholder="Street Address"
                                value={formData.address.street}
                                onChange={(e) => setFormData({ ...formData, address: { ...formData.address, street: e.target.value } })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                            />
                        </div>

                        {/* CITY FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                City
                            </label>
                            <Input
                                type="text"
                                placeholder="City"
                                value={formData.address.city}
                                onChange={(e) => setFormData({ ...formData, address: { ...formData.address, city: e.target.value } })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                            />
                        </div>

                        {/* STATE FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                State
                            </label>
                            <Input
                                type="text"
                                placeholder="State"
                                value={formData.address.state}
                                onChange={(e) => setFormData({ ...formData, address: { ...formData.address, state: e.target.value } })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                            />
                        </div>

                        {/* postal_code FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Postal Code
                            </label>
                            <Input
                                type="text"
                                placeholder="Postal Code"
                                value={formData.address.postal_code}
                                onChange={(e) => setFormData({ ...formData, address: { ...formData.address, postal_code: e.target.value } })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                            />
                        </div>

                        {/* COUNTRY FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Country <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Select
                                value={formData.address.country}
                                onChange={(value) => setFormData({ ...formData, address: { ...formData.address, country: value } })}
                                placeholder="Select Country"
                                style={{
                                    width: '100%',
                                }}
                                required
                            >
                                <Select.Option value="">Select Country</Select.Option>
                                <Select.Option value="India">India</Select.Option>
                                <Select.Option value="USA">USA</Select.Option>
                                <Select.Option value="UK">UK</Select.Option>
                                <Select.Option value="Canada">Canada</Select.Option>
                                <Select.Option value="Australia">Australia</Select.Option>
                                <Select.Option value="Germany">Germany</Select.Option>
                                <Select.Option value="France">France</Select.Option>
                                <Select.Option value="Japan">Japan</Select.Option>
                                <Select.Option value="China">China</Select.Option>
                                <Select.Option value="Other">Other</Select.Option>
                            </Select>
                        </div>

                        {/* USERNAME FIELD */}
                        <div>
                            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: COLORS.textSecondary }}>
                                Username <span style={{ color: COLORS.gold }}>*</span>
                            </label>
                            <Input
                                type="text"
                                placeholder="Username"
                                value={formData.username}
                                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                                style={{
                                    background: COLORS.background,
                                    borderColor: COLORS.gold,
                                    color: COLORS.textPrimary,
                                }}
                                required
                            />
                        </div>

                        {/* SUBMIT BUTTON */}
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            style={{
                                width: '100%',
                                gridColumn: '1 / -1',
                                background: COLORS.gold,
                                color: '#000',
                                border: 'none',
                                height: '40px',
                                fontSize: '16px',
                                fontWeight: 700,
                                marginTop: 16,
                            }}
                        >
                            {loading ? 'Creating Account...' : 'Create Account'}
                        </Button>

                        {/* LOGIN LINK */}
                        <p style={{ textAlign: 'center', color: COLORS.textSecondary, fontSize: 14, gridColumn: '1 / -1' }}>
                            Already have an account?{' '}
                            <button
                                onClick={() => navigate("/login")}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: COLORS.gold,
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    textDecoration: 'underline',
                                }}
                            >
                                Sign In
                            </button>
                        </p>
                    </form>
                </div>
            </section>

            {/* FOOTER */}
            <footer style={{ padding: 32, textAlign: 'center', color: COLORS.textSecondary }}>
                © {new Date().getFullYear()} Carats & Gold — Luxury Jewellery Manufacturers
            </footer>
        </div>
    );
}

/* ---------------- STYLES ---------------- */

const navBtnStyle = {
    background: 'none',
    border: 'none',
    color: COLORS.textSecondary,
    cursor: 'pointer',
    fontSize: 14,
};

const primaryBtnStyle = {
    padding: '14px 40px',
    background: COLORS.gold,
    color: '#000',
    border: 'none',
    borderRadius: 30,
    fontWeight: 700,
    cursor: 'pointer',
};

const secondaryBtnStyle = {
    ...primaryBtnStyle,
    background: COLORS.silver,
};

const sectionTitle = {
    textAlign: 'center',
    fontSize: 42,
    marginBottom: 56,
};

const featureGrid = {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 32,
};

const productGrid = {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: 40,
};

const productCard = {
    background: COLORS.surface,
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
};

const productImage = {
    width: '100%',
    height: 260,
    objectFit: 'cover',
};

const tag = {
    background: '#222',
    color: COLORS.gold,
    padding: '6px 12px',
    borderRadius: 20,
    fontSize: 12,
};

const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    background: COLORS.background,
    border: `1px solid ${COLORS.gold}`,
    borderRadius: 8,
    color: COLORS.textPrimary,
    fontSize: 14,
    boxSizing: 'border-box',
    fontFamily: 'Inter, sans-serif',
};

function Feature({ icon: Icon, title, desc }) {
    return (
        <div style={{ background: '#1F1F1F', padding: 32, borderRadius: 16, textAlign: 'center' }}>
            <Icon size={40} color={COLORS.gold} />
            <h3 style={{ marginTop: 16 }}>{title}</h3>
            <p style={{ color: COLORS.textSecondary }}>{desc}</p>
        </div>
    );
}
